export const determineCase = (percentageChange) => {
    if (percentageChange > 2) {
      return 1;
    } else if (percentageChange <= -2) {
      return 3;
    } else {
      return 2;
    }
  }

export const calculatePercentageChange = (currentValue, lastYearValue) => {
    if (lastYearValue === 0 && currentValue === 0) {
      return 0;
    }
    if (lastYearValue === 0) {
      return 'undefined';
    }
    return ((currentValue - lastYearValue) / (lastYearValue)) * 100;
  }